import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { GenericSelectMultiple } from '../../components';
import { InputModelWithSource } from '../../models';
import { InputWithSource } from '../../componentTypes';

const AdditionalClassificationInput: InputWithSource = ({ input }) => (
    <GenericSelectMultiple
        label={input.name}
        input={input}
        disabled={input.parentInputs.length > 0 && input.parentInputs.every(parentInput => !parentInput.hasValue)}
    />
);

AdditionalClassificationInput.meta = {
    inputType: InputModelWithSource.name
};

export default observer(AdditionalClassificationInput);
